import { render } from "./SmBtn.vue?vue&type=template&id=eb10b4e0&scoped=true"
import script from "./SmBtn.vue?vue&type=script&lang=js"
export * from "./SmBtn.vue?vue&type=script&lang=js"

import "./SmBtn.vue?vue&type=style&index=0&id=eb10b4e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb10b4e0"]])

export default __exports__